<script setup lang="ts">
import ConfirmModal from 'gpcore-uikit/components/new/ConfirmModal.vue';

const { isOpened, projectName } = defineProps<{
  isOpened: boolean;
  projectName?: string;
}>();

const emit = defineEmits<{
  confirm: [];
  decline: [];
}>();
</script>

<template>
  <ConfirmModal
    :show="isOpened"
    confirm-type="primary"
    @close="emit('decline')"
    @confirm="emit('confirm')"
  >
    <template #content>
      <p class="tw-px-4">
        Are you sure you want to decline the invitation to project
        <span class="tw-text-bold tw-text-gp-cyan"> {{ projectName }} </span>?
      </p>
      <p class="tw-mb-4 tw-px-4">
        You are not able to join the project, unless the owner of the project sends an invitation
        again.
      </p>
    </template>
  </ConfirmModal>
</template>

<style scoped></style>
